var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "skeleton-wrapper",
    { staticClass: "_flexcol _gap-2" },
    [
      _c("box", { staticClass: "_flexcol _gap-3" }, [
        _c(
          "div",
          { staticClass: "_flex _jc-sb" },
          [
            _c(
              "div",
              { staticClass: "_flex _gap-2 _pos-r _w-100" },
              [
                _c("skeleton-image", { attrs: { size: 42 } }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "_flexcol _gap-1 _w-100" },
                  [
                    _c("skeleton-line", {
                      attrs: { height: 18, "width-percent": 30 },
                    }),
                    _vm._v(" "),
                    _c("skeleton-line", {
                      attrs: { height: 18, "width-percent": 45 },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("skeleton-line", { attrs: { height: 18, "width-percent": 15 } }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "_flexcol _gap-3" },
          [
            _c("skeleton-line", { attrs: { height: 22, "width-percent": 50 } }),
            _vm._v(" "),
            _c("skeleton-line", { attrs: { height: 22, "width-percent": 25 } }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }